import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_URL_LINK_UPDATE, TICKET_LIST_ALL_URL_LINK_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconUrlLink from '../../assets/icons/IconUrlLink';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketURL extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUrlModal: false,
            url: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
        this.inputRef = React.createRef();
    }

    handleCopy = () => {
        this.inputRef.current.select();
        this.inputRef.current.setSelectionRange(0, 99999);
        document.execCommand("copy");
        alert("Copied the text: " + this.inputRef.current.value);
    }

    handleOpen = () => {
        this.setState({
            url: this.props.data.link_storage,
            showUrlModal: true
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            link_storage: this.state.url,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataUrlLink(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showUrlModal: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                this.props.refresh();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    urlLinkReadOnly = () => {
        if (!this.checkPermissionUrl() || !this.checkCustomerServiceAssignee()) {
            return (
                <div className="flex flex-row-reverse items-center">
                    <button type="button" id="btnclose" className="bg-lightblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showUrlModal: false })}>Tutup</button>
                    <button type="button" id="btncopy" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleCopy()}>Copy</button>
                </div>
            )
        }
        return null
    }

    checkPermissionUrl = () => {
        if ((CheckPermissionApi(TICKET_LIST_ALL_URL_LINK_UPDATE, this.props.userDetail.permissions)
            || CheckPermissionApi(TICKET_LIST_ALL_URL_LINK_UPDATE_ASSIGNEE, this.props.userDetail.permissions))
            && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            return true
        }
        return false
    }

    checkStatusTicket = () => {
        if (this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS) return true
        return false
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
        return true
    }

    render() {
        return (
            <>
                <button type="button" id="btnurllink" className={this.checkStatusTicket() ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.handleOpen()}>
                    <IconUrlLink />
                    <span className="ml-1">URL Link</span>
                </button>

                <div className={this.state.showUrlModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/3">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnurllinkclose" onClick={() => this.setState({ showUrlModal: false })} />
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <p className="text-darkblue text-center text-3xl font-medium">URL Link</p>
                                <textarea id="tmlurl" className="form-control resize-none text-2xl text-darkblue h-40 my-5" placeholder="Masukan URL Link" name="url" ref={this.inputRef} value={this.state.url} onChange={this.handleChange} disabled={!this.checkPermissionUrl() || !this.checkCustomerServiceAssignee()} />
                                <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_URL_LINK_UPDATE, TICKET_LIST_ALL_URL_LINK_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                    <div className={this.checkPermissionUrl() && this.checkCustomerServiceAssignee() ? "flex justify-between items-center" : "hidden"}>
                                        <div>
                                            <button type="submit" id="btnsave" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3 mr-2">Ubah URL</button>
                                            <button type="button" id="btncopy" className="bg-darkblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.handleCopy()}>Copy</button>
                                        </div>
                                        <button type="button" id="btnclose" className="bg-lightblue rounded-lg text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showUrlModal: false })}>Tutup</button>
                                    </div>
                                </CheckPermissionComponent>
                                <this.urlLinkReadOnly />
                            </form>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketURL);